import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=3f3925b8&scoped=true"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"
import style0 from "./PendingTasks.vue?vue&type=style&index=0&id=3f3925b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3925b8",
  null
  
)

export default component.exports